import type { ReactNode } from 'react'
import { FONTES, type IdFonte } from '../../../dominio/produtos'

/**
 * Valor com a sigla da fonte ao lado. A sigla é link para a referência quando
 * há URL, e o título traz a referência completa e a observação do valor
 * ("a 20 °C", "convertido de 0,9 mi") — o aluno sempre pode ver de onde o
 * número saiu.
 */
export function ValorCitado({ children, fonte, observacao }: { children: ReactNode; fonte: IdFonte; observacao?: string }) {
  const referencia = FONTES[fonte]
  const titulo = observacao ? `${referencia.titulo} — ${observacao}` : referencia.titulo
  return (
    <span className="valor-citado">
      {children}
      {referencia.url ? (
        <a className="valor-citado__fonte" href={referencia.url} target="_blank" rel="noreferrer" title={titulo}>
          {referencia.sigla}
        </a>
      ) : (
        <span className="valor-citado__fonte" title={titulo}>
          {referencia.sigla}
        </span>
      )}
    </span>
  )
}
